<template>
  <div class="w-full mb-3 flex items-center">
    <div class="flex-1">
      <div class="text-md font-semibold text-brand-gray-800 tracking-tight">
        {{ topAddressLine }}
      </div>
      <div class="text-sm text-brand-gray-600 tracking-wide">
        {{ bottomAddressLine }}
      </div>
      <div v-if="notes" class="text-sm text-brand-gray-600 tracking-wide">
        {{ notes }}
      </div>
    </div>

    <div class="flex items-center space-x-2">
      <span
        v-if="isDefault"
        class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
      >
        Default
      </span>
      <button
        v-if="!locked"
        class="inline-flex items-center shadow-sm p-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full bg-white hover:border-blue-600 transition-all duration-150 group-hover:opacity-100 text-gray-500 hover:text-blue-600"
        @click="editAddress"
        :disabled="isLoading"
      >
        <PencilIcon class="h-4 w-4" aria-hidden="true" />
      </button>
      <button
        v-if="!locked"
        class="inline-flex items-center shadow-sm p-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full bg-white hover:border-red-600 transition-all duration-150 group-hover:opacity-100 text-gray-500 hover:text-red-600"
        @click="removeAddress"
        :disabled="isLoading"
      >
        <XIcon class="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script>
import { PencilIcon, XIcon } from '@heroicons/vue/solid'

export default {
  name: 'DeliveryAddressRow',
  components: {
    PencilIcon,
    XIcon
  },
  props: {
    deliveryAddress: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    topAddressLine() {
      const a = this.deliveryAddress.attributes
      return [a.address1, a.address2].filter(Boolean).join(', ')
    },
    bottomAddressLine() {
      const a = this.deliveryAddress.attributes
      return [a.city, a.state, a.zip].filter(Boolean).join(', ')
    },
    notes() {
      return this.deliveryAddress.attributes.notes
    },
    isDefault() {
      return !!this.deliveryAddress.attributes.is_default
    }
  },
  methods: {
    editAddress() {
      this.$emit('edit-address', this.deliveryAddress)
    },
    removeAddress() {
      this.$emit('remove-address', this.deliveryAddress)
    }
  }
}
</script>
